module.exports = __webpack_public_path__ + "img/speaker.eb956992.svg";